import { Container, Row, Col, Carousel, Image } from "react-bootstrap";
import { ALL_THE_BANNERS } from "./WelcomeCarouselConstants";

function WelcomeCarousel() {
  return (
    <Container fluid>
      <Row>
        <Col xs={12}>
          <Carousel>
            {ALL_THE_BANNERS.map((b) => (
              <Carousel.Item>
                <a href={b.link} target={b.target}>
                  <Image src={b.image} width={b.width} />
                </a>
              </Carousel.Item>
            ))}
          </Carousel>
        </Col>
      </Row>
    </Container>
  );
}
export default WelcomeCarousel;
